import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost, apiDelete } from "@/lib/api";
import type {
  MicrosoftOAuthStatus,
  MicrosoftOAuthInitiateResponse,
  MicrosoftOAuthCallbackRequest,
  MicrosoftOAuthCallbackResponse,
} from "@/types/api";

export function useMicrosoftOAuthStatus() {
  return useQuery<MicrosoftOAuthStatus>({
    queryKey: ["microsoft-oauth-status"],
    queryFn: () => apiGet("/api/v1/oauth/microsoft/status"),
  });
}

export function useInitiateMicrosoftOAuth() {
  return useMutation<MicrosoftOAuthInitiateResponse, Error>({
    mutationFn: () => apiPost("/api/v1/oauth/microsoft/initiate", {}),
  });
}

export function useCompleteMicrosoftOAuth() {
  const qc = useQueryClient();
  return useMutation<MicrosoftOAuthCallbackResponse, Error, MicrosoftOAuthCallbackRequest>({
    mutationFn: (data) => apiPost("/api/v1/oauth/microsoft/callback", data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["microsoft-oauth-status"] });
      qc.invalidateQueries({ queryKey: ["integrations"] });
      qc.invalidateQueries({ queryKey: ["onboarding"] });
    },
  });
}

export function useDisconnectMicrosoftOAuth() {
  const qc = useQueryClient();
  return useMutation<{ status: string; message: string }, Error>({
    mutationFn: () => apiDelete("/api/v1/oauth/microsoft/connection"),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["microsoft-oauth-status"] });
      qc.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
}
